export default {
  Title: 'Manage Accounts',
  Country: 'Country',
  FullName: 'Full Name',
  PhoneNumber: 'Phone Number',
  Role: 'Role',
  SystemManager: 'System Manager',
  PartnerManager: 'Partner Manager',
  Sales: 'Sales',
  ResetPassword: 'Reset Password',
  EditAccount: 'Edit Account',
  Delete: 'Delete',
  ResetPasswordNotify: 'Are you sure you want to reset this password?',
  Yes: 'Yes',
  No: 'No',
  YesNotify: 'A new password has been set to your account',
  Ok: 'OK',
  PasswordChangedNotify:
    'Password has changed. Please log out and log in again after finishing your current work.',
  DeleteTitle: 'Delete Account?',
  DeleteText: 'Are you sure you want to delete {name} account?',
  Cancel: 'Cancel',
  FullName: 'Full name',
  PhoneNumber: 'Phone number',
  Email: 'Email',
  Total: 'Total: {number} users',
  Search: 'Search',
  Filter: 'Filter',
  AddAccount: 'Add Account',
  Type: 'Type',
  All: 'All',
  Save: 'Save',
  InfoTitle: 'Information',
  Success: 'Update successfully',
  Fail: 'Update failed',
  Partner: 'Partner',
};
